<div
  class="side-bar"
  [ngClass]="{
    collapsed: collapsed
  }"
>
  <div
    class="logo-bar"
    [ngClass]="{
      center: collapsed
    }"
  >
    <div class="logo-container">
      <img class="logo" [src]="logo" />
    </div>

    <div *ngIf="!collapsed" class="app-title">
      {{ title }}
    </div>
  </div>

  <div
    class="buttons-wrapper"
    [ngClass]="{
      'bar-padding': collapsed
    }"
  >
    <div class="top-buttons">
      <div *ngFor="let navButton of navButtons">
        <keycom-nav-button
          [active]="navButton.active"
          [condition]="true"
          [collapsed]="collapsed"
          [content]="navButton.name"
          [icon]="navButton.icon"
          [aria]="'This is a sample button'"
          (onClick)="select(navButton)"
        >
        </keycom-nav-button>
      </div>
      <!-- Feature Management Button (SuperUser only) -->
      <div *ngIf="user?.isSuperUser === true">
        <keycom-nav-button
          [active]="isFeaturesActive"
          [condition]="true"
          [collapsed]="collapsed"
          [content]="'Features'"
          [icon]="'layout'"
          [aria]="'Feature Management'"
          (onClick)="navigateToFeatures()"
          class="feature-button"
        >
        </keycom-nav-button>
      </div>
      <!-- Notification Management Button -->
      <div *featureFlag="'NOTIFICATION_VIEW'">
        <keycom-nav-button
          [active]="isNotificationsActive"
          [condition]="true"
          [collapsed]="collapsed"
          [content]="'Notifications'"
          [icon]="'notification'"
          [aria]="'Notification Management'"
          (onClick)="navigateToNotifications()"
        >
        </keycom-nav-button>
      </div>
    </div>

    <div class="bottom-buttons">
      <!-- collapse -->
      <keycom-nav-button
        [condition]="collapsed"
        [icon]="'extend'"
        [aria]="'This is a sample button'"
        (onClick)="toggleCollaped()"
      >
      </keycom-nav-button>
      <keycom-nav-button
        [content]="'Collapse'"
        [condition]="!collapsed"
        [icon]="'collapse'"
        [aria]="'This is a sample button'"
        (onClick)="toggleCollaped()"
      >
      </keycom-nav-button>

      <!-- Backdrop -->
      <!-- <div class="popup-backdrop" (click)="close()" *ngIf="menuOn || helpMenuOn"></div> -->
      <popup-backdrop (click)="close()" *ngIf="menuOn || helpMenuOn"></popup-backdrop>

      <!-- Help -->
      <keycom-nav-button
        [condition]="helpActions"
        [clear]="true"
        [content]="'Support'"
        [collapsed]="collapsed"
        [icon]="'help'"
        [iconLeft]="true"
        [aria]="'This is a sample button'"
        (click)="showHelp($event)"
      >
      </keycom-nav-button>

      <!-- <div *ngIf="helpMenuOn" [ngStyle]="{ 'left.px': widthExp, 'bottom.px': heightExp }"> -->
      <dropdown-card *ngIf="helpMenuOn" [ngStyle]="{ 'left.px': widthExp, 'bottom.px': heightExp }">
        <!-- List Buttons -->
        <div *ngFor="let helpAction of helpActions">
          <button mat-icon-button (click)="clickHelp(helpAction)">
            <keycom-nav-icon [color]="'#393E46'" [iconName]="helpAction.icon" class="unclickable"></keycom-nav-icon>
          </button>
        </div>
      </dropdown-card>
      <!-- </div> -->

      <!-- Profile  -->
      <keycom-nav-button
        [condition]="profileActions"
        [clear]="true"
        [content]="user.name"
        [collapsed]="collapsed"
        [iconLeft]="true"
        [aria]="'This is a sample button'"
        (click)="show($event)"
        [chip]="true"
      >
        <mat-chip size="auto" class="margin sm right profile-initials">
          {{ user.initials }}
        </mat-chip>
      </keycom-nav-button>

      <dropdown-card *ngIf="menuOn" [ngStyle]="{ 'left.px': widthExp, 'bottom.px': heightExp }">
        <!-- Header -->
        <popover-card-header>
          <mat-chip size="auto">
            {{ user.initials }}
          </mat-chip>

          <div class="row">
            <div style="margin-left: 16px">
              <div class="col">
                <span class="user-name">{{ user.name }}</span>
                <mat-chip
                  *ngIf="user.chip"
                  size="auto"
                  size="auto"
                  class="margin sm right profile-initials"
                  [color]="'#3E93F4'"
                >
                  {{ user.initials }}
                </mat-chip>
                <div>
                  <div class="row">
                    <mat-icon>email</mat-icon>
                    <span class="user-details">{{ user.email }}</span>
                  </div>
                  <div class="row">
                    <mat-icon>mode_edit</mat-icon>
                    <span class="user-details">{{ user.address }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </popover-card-header>

        <!-- List Buttons -->
        <div *ngFor="let profileAction of profileActions">
          <keycom-nav-button
            [condition]="true"
            [clear]="true"
            [content]="profileAction.name"
            [icon]="profileAction.icon"
            [iconLeft]="true"
            [aria]="'This is a sample button'"
            (click)="clickProfile(profileAction)"
          ></keycom-nav-button>
        </div>
      </dropdown-card>
    </div>
  </div>
</div>
